import { render, staticRenderFns } from "./QuizView.vue?vue&type=template&id=1aa6cde6&"
import script from "./QuizView.vue?vue&type=script&lang=js&"
export * from "./QuizView.vue?vue&type=script&lang=js&"
import style0 from "./QuizView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports